<template>

	<div 
		:class="{ tip: true, fromLeft: position === 'fromLeft', fromRight: position === 'fromRight', fromCentre: position === 'fromCentre', fromCenter: position === 'fromCenter', show: show, small: true, extensive: extensive }" 
		:style="styles" 
		@click="showClick"
	>

		<span v-html="label" class="tip-label" :style="labelStyles" />

		<div class="tip-info"><p><slot></slot></p></div>

	</div>

</template>

<script>
export default {
	name: 'Tip',
	props: {
		label: {
			type: String,
			default: '?'
		},
		title: {
			type: String,
			default: ''
		},
		extensive: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: 'fromLeft'
		},
		styles: {
			type: Object,
			default: function () { return {} }
		},
		labelStyles: {
			type: Object,
			default: function () { return {} }
		}
	},
	data() {

		return {
			show: false
		}

	},
	methods: {

		showClick () {

			if ( this.show ) {

				this.show = false;

			}
			else {

				const isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

				if ( isTouch ) {

					this.show = true;

				}

			}

		}

	}
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';

.tip {

	position:relative;
	display: inline-block;
	z-index: 3;

	.tip-label {

		display: inline-block;
	    position: relative;
	    background-color: @formDefaultColour;
	    color: #fff;
	    padding: 4px 8px 3px;
	    line-height: 1em;
	    .rounded(50%);
	    cursor: pointer;
	    vertical-align: top;

	}

	&.grey {

		.tip-label {

			background-color: #666;

		}

	}

	&.hideQ {

		position: absolute;
		z-index: 2;
		width: 100%;
		height: 100%;
		z-index: 3;
		left: 0;
		top: 0;
		margin: 0;

		.tip-label {

			display: none;

		}

	}

	.tip-info {

		display: none;
		position: absolute;
		z-index: 5;
		top: 20px;
		left: 0;

		p {

			padding:10px;
			margin: 5px 0 0;
			font-size:12px;
			width:200px;
			background-color:rgba(0,0,0,0.8);
			color: #fff;
			text-transform: none;
			text-align: left;
			.rounded(5px);

			span {

				color: inherit;

			}

			a {

				color: #fff;
				text-decoration: underline;

			}

		}

	}

	&.extensive {

		.tip-info {

			p {

				width:500px;
				max-width: 90vw;

			}

		}

	}

	&.fromCenter, &.fromCentre {

		.tip-info {

			left: 50%;
			margin-left: -100px;

		}

	}

	&.fromRight {

		.tip-info {

			right: 0;
			left: auto;

		}

	}

	&.small {

		.tip-label {

			font-size: 10px;
			padding: 4px 6px 3px;

		}

	}

	&.mini {

		.tip-label {

			font-size: 10px;
			padding: 2px 4px 1px;

		}

	}

	&:hover, &.show {

		overflow: visible;

		.tip-info {

			display: block;

		}

	}

}
</style>